import { useEffect, useState } from 'react';
import {
  ExtensionMenuItemsState,
  ExtensionMenuItemsStateParams,
} from '../state/ExtensionMenuItemsState';
import { useWixPatternsContainer } from '@wix/bex-core/react';

export function useExtensionMenuItems(
  params: Omit<ExtensionMenuItemsStateParams, 'container'>,
) {
  const container = useWixPatternsContainer();

  const [state] = useState(() => {
    return new ExtensionMenuItemsState({ ...params, container });
  });

  useEffect(() => state.init(), []);

  return state;
}
